import HttpMethod from 'sources/http-methods';

export class PzCampaignSource {
  public async getCampaign(programName: string) {
    return await fetch(`/api/v1/pz/campaign/${programName}`, {
      method: HttpMethod.GET,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((campaign) => {
        // tslint:disable-next-line:no-console
        console.log('Campaign returned for ', programName);

        return campaign;
      })
      .catch((err) => {
        // tslint:disable-next-line:no-console
        console.log('Error fetching Campaign for ', programName);

        throw err;
      });
  }
}
